import { Box, BoxProps, Icon, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useState } from 'react'
import { KeyboardAwareModal } from '../../comps/KeyboardAwareModal/KeyboardAwareModal'
import { paymentDetailsStrings } from '../../data/static/strings'
import { useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { TextLayout } from './TextLayout'

interface DetailsProps {
  txnId: string
  handleClose: () => void
  isRefundModalVisible: boolean
  path: string
  tab: string
}

const RefundDetailsAccordion = ({ data, index }: any) => {
  const [visibleSection, setVisibleSection] = useState(-1)

  const getId = (index: number) => {
    if (index === visibleSection) {
      return 'ARROW_UP'
    }
    return 'ARROW_DOWN'
  }

  const openSection = (value: number) => {
    if (value === visibleSection) {
      setVisibleSection(-1)
    } else {
      setVisibleSection(value)
    }
  }
  const RefundDetailsItem = ({ dataItem, itemIndex }: any) => {
    return (
      <Box {...sectionStyles.sectionBox} onPress={() => openSection(itemIndex)} key={dataItem + itemIndex}>
        <Box flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Text {...sectionStyles.sectionText}>{`Refund ${itemIndex + 1}`}</Text>
          <Icon size="BIG" id={getId(itemIndex)} color="BLACK_21" />
        </Box>
        {itemIndex === visibleSection && <TextLayout title={dataItem} data={dataItem} key={dataItem + itemIndex} />}
        <Box height={1} backgroundColor={'GREY_SEPARATOR'} marginVertical={16} />
      </Box>
    )
  }

  return (
    <Box underlayColor={'TRANSPARENT'} paddingHorizontal={6} key={'refund_accordian_' + index}>
      <Text {...sectionStyles.sectionText}>{paymentDetailsStrings.labelRefundDetails}</Text>
      <Spacer direction="vertical" size={24} />
      {data.map((item: any, index: any) => {
        return <RefundDetailsItem dataItem={item} itemIndex={index} key={index} />
      })}
    </Box>
  )
}

export const DetailsLayout: FC<DetailsProps> = ({
  txnId,
  handleClose,
  isRefundModalVisible,
  path,
  tab,
}: DetailsProps) => {
  const navigation = useNavigation()
  const { getKeyValues, getTxnRemainingAmtToRefund, initiateSingleRefund, getTxnDetails } = useStores((store) => ({
    getKeyValues: store.transactions.getTxnDetilsKeyValues,
    getTxnRemainingAmtToRefund: store.transactions.getTxnRemainingAmtToRefund,
    initiateSingleRefund: store.transactions.initiateSingleRefund,
    getTxnDetails: store.transactions.newTransactionDetails,
  }))
  const isSodexoTxn = getTxnDetails(path)?.paymentDetails.paymentMode === 'Sodexo'
  const data = getKeyValues(txnId, path, tab)
  let status = data?.status?.toLowerCase() ?? ''

  const remainingAmount = getTxnRemainingAmtToRefund(tab)

  const handleNavigation = (msg: string, navigateTo: string, amount: string, statusTxn: string, trxnId: string) => {
    navigation.navigate(Routes.SUCCESS, {
      message: msg,
      navigateTo: navigateTo,
      amount: amount,
      status: statusTxn,
      txnId: trxnId,
    })
  }
  return (
    <Box key={txnId}>
      <TextLayout title={'Transaction Details'} data={data} />
      <KeyboardAwareModal
        totalAmount={remainingAmount}
        status={status}
        route={Routes?.TRANSACTIONS}
        label="Amount to Refund"
        headerText="Amount to Refund"
        buttonText="Initiate Refund"
        visible={isRefundModalVisible}
        hideModal={handleClose}
        txnId={txnId}
        navigateToSuccess={handleNavigation}
        initiateSingleRefund={initiateSingleRefund}
        showInvoiceId={isSodexoTxn}
      />
    </Box>
  )
}

const sectionStyles = {
  sectionBox: {
    underlayColor: 'TRANSPARENT',
    backgroundColor: 'TRANSPARENT',
  } as BoxProps,
  sectionText: {
    fontWeight: 'bold',
    color: 'BLACK',
    fontSize: 16,
  } as TextProps,
}
